module.exports = __webpack_public_path__ + "home_s1.png?713c557a7d10baaa93e4a21fd100a91e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_s1.png
// module id = 47
// module chunks = 0